import axios from "axios";

export default {
  getVersion() {
    return axios
      .get("api/sistema/version")
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },
};
